import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  input,
  output,
} from '@angular/core';
import { FormsModule } from '@angular/forms';
import { DropdownItem, DropdownModule } from '@vinnova/ui';
import { ExcelImportSourceRow } from '../excel-import-modal/excel-import-modal.model';

export interface ExcelImportSourceRowsTexts {
  title: string;
  help: string;
  label: string;
  source: string;
  slot: string;
  suggested: string;
  summed: string;
}

export interface ExcelImportSourceRowChange {
  key: string;
  slot: string;
}

/** Lists the rows read from the file and lets the user decide which slot each one is placed in. */
@Component({
  selector: 'lib-excel-import-source-rows',
  templateUrl: './excel-import-source-rows.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, FormsModule, DropdownModule],
})
export class ExcelImportSourceRowsComponent {
  readonly idPrefix = input.required<string>();
  readonly rows = input.required<ExcelImportSourceRow[]>();
  readonly years = input.required<number[]>();
  readonly slotOptions = input.required<DropdownItem[]>();
  readonly texts = input.required<ExcelImportSourceRowsTexts>();
  readonly columnLabels = input<Record<number, string>>({});

  readonly slotChange = output<ExcelImportSourceRowChange>();
}
